goog.provide("shadow.js.shim.module$dayjs$locale$he");
goog.provide("module$shadow_js_shim_module$dayjs$locale$he");
shadow.js.shim.module$dayjs$locale$he = shadow.js.nativeProvides["dayjs/locale/he"] = require("dayjs/locale/he");
module$shadow_js_shim_module$dayjs$locale$he.default = shadow.js.shim.module$dayjs$locale$he;
